module.exports = __webpack_public_path__ + "img/no-3.b3d812dc.svg";